import React from "react";
import Image from "../Image/Image";
import parseHTML from "../../helpers/parseHTML";
import { GlobalContext } from "../../context/GlobalContext";
import StockInfo from "../StockInfo/StockInfo";

function BlogPostAdd({ data, visible, setShowVisible, category, releaseDate }) {
  const { isMobile } = React.useContext(GlobalContext);

  //* useEffect to prevent overflow if BlogPostAdd is visible
  React.useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [visible]);

  //* if mobile device return offcanvas from bottom
  if (isMobile)
    return (
      <div
        className={`offcanvas offcanvas-bottom article-secondary-mobile ${
          visible && "article-secondary-visible show"
        }`}
        tabIndex="-1"
        id="offcanvasBottom"
        aria-labelledby="offcanvasLabel"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="btn-close-custom dismiss-active-or-focus"
          >
            <i
              className="icon-click icon-close bi bi-x-lg text-muted"
              onClick={() => setShowVisible((prev) => !prev)}
            />
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="article-secondary-info">
            <a href={data?.homepage} target="_blank">
              {data?.logo && (
                <Image source={data?.logo} className="article-logo" />
              )}
            </a>

            <h4 className="text-dark text-muted text-truncate">{data?.name}</h4>

            <div
              id="data-description"
              className="text-muted text-left article-base-description-active"
            >
              {data?.description && parseHTML(data?.description)}
            </div>
            {data?.stockdata && (
              <>
                <br />
                <StockInfo
                  noAccordion
                  stockdata={data?.stockdata}
                  releaseDate={releaseDate}
                />
              </>
            )}
          </div>
        </div>
      </div>
    );

  //* else return offcanvas from right
  return (
    <div
      className={`offcanvas offcanvas-end article-secondary  ${
        visible && "article-secondary-visible show"
      }`}
      tabIndex="-1"
      id="offcanvas"
      aria-labelledby="offcanvasLabel"
    >
      <div className="offcanvas-header">
        <button
          type="button"
          className="btn-close-custom dismiss-active-or-focus"
        >
          <i
            className="icon-click icon-close bi bi-x-lg text-muted"
            onClick={() => setShowVisible((prev) => !prev)}
          />
        </button>
      </div>
      <div className="offcanvas-body">
        <div className="article-secondary-info">
          <a href={data?.homepage} target="_blank">
            {data?.logo && (
              <Image source={data?.logo} className="article-logo" />
            )}
          </a>

          <h4 className="text-dark text-muted text-truncate">{data?.name}</h4>

          <div
            id="data-description"
            className="text-muted text-left article-base-description-active"
          >
            {data?.description && parseHTML(data?.description)}
          </div>
          {data?.stockdata && (
            <>
              <br />
              <StockInfo
                noAccordion
                stockdata={data?.stockdata}
                releaseDate={releaseDate}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default BlogPostAdd;
